/**
 * Rollen & Permissies Service
 */

import apiFetch from './api';

export interface Permissie {
  id: number;
  naam: string;
  omschrijving: string | null;
  categorie: string | null;
  actief: boolean;
}

export interface Rol {
  id: number;
  naam: string;
  omschrijving: string | null;
  actief: boolean;
  permissies: Permissie[];
}

export const rollenService = {
  /**
   * Haal alle rollen op met hun permissies
   */
  async getRollen(): Promise<Rol[]> {
    return apiFetch('/api/v1/rollen');
  },

  /**
   * Haal een specifieke rol op
   */
  async getRol(rolId: number): Promise<Rol> {
    return apiFetch(`/api/v1/rollen/${rolId}`);
  },

  /**
   * Haal alle beschikbare permissies op
   */
  async getPermissies(): Promise<Permissie[]> {
    return apiFetch('/api/v1/rollen/permissies');
  },

  /**
   * Haal alle permissie categorieën op
   */
  async getCategorieen(): Promise<string[]> {
    return apiFetch('/api/v1/rollen/permissies/categorieen');
  },

  /**
   * Update de permissies van een rol
   */
  async updateRolPermissies(rolId: number, permissieIds: number[]): Promise<Rol> {
    return apiFetch(`/api/v1/rollen/${rolId}/permissies`, {
      method: 'PUT',
      body: JSON.stringify({ permissie_ids: permissieIds }),
    });
  },

  /**
   * Reset de permissies van een rol naar standaard
   */
  async resetRolPermissies(rolId: number): Promise<Rol> {
    return apiFetch(`/api/v1/rollen/${rolId}/reset`, {
      method: 'POST',
    });
  },

  /**
   * Haal de standaard permissie IDs op voor een rol
   */
  async getStandaardPermissies(rolId: number): Promise<{ permissie_ids: number[] }> {
    return apiFetch(`/api/v1/rollen/${rolId}/standaard`);
  },
};

export default rollenService;
